import React, { useEffect, useState } from "react";
import useDebtConsolidationMath, {
  REVOLVING_TYPES,
} from "./Hooks/useDebtConsolidationMath";
import "../../../css/DebtConsolidationCalculator/DebtConsolidationCalculator.css";
import { Helmet } from "react-helmet-async";
import Sidebar from "../../../frontend/DesignSystem/Sidebar";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";
import RemoveButton from "../CashflowModeller2/Components/Buttons/RemoveIcon";
import "../../../css/Components/DesignSystem/RadioButton.css";
import AddEditButton from "../CashflowModeller2/Components/Buttons/AddEditButton";
import { LockIcon } from "./HelperFunctions/LockIcon";
import { auth } from "../../../backend/firebaseconfig";
import {
  dashIfNaN,
  formatYearsMonths,
  safeFixed,
  toMoney,
  toPct,
  ccMinPayment,
  monthlyFromTerm,
} from "./HelperFunctions/helperFunctions";
import {
  aprToMonthly,
  periodsForPayment,
} from "./Hooks/useDebtConsolidationMath";
import DCCReport from "./Report/dccReport";
import { useBranding } from "../../../context/BrandingContext";
import { useUserEmail } from "../../../context/UserEmailContext";
import { pdf } from "@react-pdf/renderer";
import FormattedNumberInput from "./HelperFunctions/formatNumber";
import InputField from "../../../frontend/DesignSystem/InputField";
import ButtonYellow from "../../../frontend/DesignSystem/Buttons/ButtonYellow";
import { PDFViewer } from "@react-pdf/renderer";
import generateDCCForAllAdvisers from "./HelperFunctions/generateAllDCCReports";
import { defaultAprForLabel, AVERAGE_RATES } from "./HelperFunctions/getAvgAPR";
import { createPortal } from "react-dom";
import { ReactComponent as TooltipIcon } from "../../../assets/icons/question-mark-tooltip.svg";
import AverageRatesModal from "./Components/averageRatesModal";
import CurrentMortgageCard from "./Components/CurrentMortgageCard";
import InfoTooltip from "./DesignSystem/InfoTooltip";

import { emptyMortgage, mortgageSummary } from "./HelperFunctions/mortgageSummary";

export default function DebtConsolidationCalculator() {
  const breadcrumbItems = [
    { label: "Tools & Calculators", to: "/portal/tools-calculators" },
    { label: "DebtSense" },
  ];

  /* Existing debts */
  const [customerName, setCustomerName] = useState("");
  const [adviserName, setAdviserName] = useState(
    auth.currentUser ? auth.currentUser.displayName : "",
  );
  const [showAvgRates, setShowAvgRates] = useState(false);
  const { tradingName, primaryColor, logo, regulatoryText } = useBranding();
  const [debts, setDebts] = useState([
    //  {
    //    id: 1,
    //    label: "Unsecured Loan",
    //    lockType: false,
    //    balance: "2378",
    //    apr: "35",
    //    termYears: "1",
    //    plannedMonthly: "237.71",
    //    monthly: "237.71",
    //  },
    //  {
    //    id: 2,
    //    label: "Unsecured Loan",
    //    lockType: false,
    //    balance: "2468",
    //    apr: "20",
    //    termYears: "2",
    //    plannedMonthly: "125.61",
    //    monthly: "125.61",
    //  },
    //  {
    //    id: 3,
    //    label: "Credit Card",
    //    lockType: false,
    //    balance: "1424",
    //    apr: "29.4",
    //    termYears: "2.33",
    //    plannedMonthly: "71",
    //    monthly: "71",
    //  },
    //  {
    //    id: 4,
    //    label: "Credit Card",
    //    lockType: false,
    //    balance: "391",
    //    apr: "34.9",
    //    termYears: "2.5",
    //    plannedMonthly: "20",
    //    monthly: "20",
    //  },
    //  {
    //    id: 5,
    //    label: "Overdraft",
    //    lockType: false,
    //    balance: "497",
    //    apr: "39",
    //    termYears: "2.75",
    //    plannedMonthly: "24.85",
    //    monthly: "24.85",
    //  },
    //  {
    //    id: 6,
    //    label: "Overdraft",
    //    lockType: false,
    //    balance: "100",
    //    apr: "39.9",
    //    termYears: "2.83",
    //    plannedMonthly: "5",
    //    monthly: "5",
    //  },
    //  {
    //    id: 7,
    //    label: "Secured Loan",
    //    lockType: false,
    //    balance: "30362",
    //    apr: "18.35",
    //    termYears: "4",
    //    plannedMonthly: "897.45",
    //    monthly: "897.45",
    //  },
    //  {
    //    id: 8,
    //    label: "Credit Card",
    //    lockType: false,
    //    balance: "1300",
    //    apr: "23.9",
    //    termYears: "2.17",
    //    plannedMonthly: "65",
    //    monthly: "65",
    //  },
    //  {
    //    id: 9,
    //    label: "Unsecured Loan",
    //    lockType: false,
    //    balance: "897",
    //    apr: "22.9",
    //    termYears: "1",
    //    plannedMonthly: "84.34",
    //    monthly: "84.34",
    //  },
    //  {
    //    id: 10,
    //    label: "Unsecured Loan",
    //    lockType: false,
    //    balance: "60000",
    //    apr: "1.75",
    //    termYears: "10",
    //    plannedMonthly: "545.39",
    //    monthly: "545.39",
    //  },
  ]);

  const [currentMortgages, setCurrentMortgages] = useState(() => [{ ...emptyMortgage(), id: 1 }]);
  const currentMortgage = mortgageSummary(currentMortgages);
  const updateMortgage = (id, update) => {
    setCurrentMortgages(previous => previous.map(mortgage => mortgage.id === id
      ? (typeof update === 'function' ? update(mortgage) : update)
      : mortgage));
  };

  const hasCurrentMortgage = debts.some(
    (d) => (d.label || "").trim() === "Current Mortgage",
  );
  const { userEmail } = useUserEmail();
  const typesInDebts = [
    "Credit Card",
    "Store Card",
    "Overdraft",
    "Unsecured Loan",
    "Secured Loan",
    "Car Finance",
    // "Current Mortgage",
    "Other",
  ];

  /* Consolidation mortgage */
  const [loanAmount, setLoanAmount] = useState("");

  // Stepped rates
  const [initialApr, setInitialApr] = useState("");
  const [svrApr, setSvrApr] = useState("");

  // Initial (intro) period
  const [initialYears, setInitialYears] = useState("");
  const [initialMonths, setInitialMonths] = useState("");

  // Total loan term
  const [termYears, setTermYears] = useState("");
  const [termMonths, setTermMonths] = useState("");

  // Fees
  const [feeMode, setFeeMode] = useState("flat"); // 'flat' | 'percent'
  const [feeValue, setFeeValue] = useState("");

  const [initialMonthlyOverride, setInitialMonthlyOverride] = useState(""); // GBP per month
  const [reversionMonthlyOverride, setReversionMonthlyOverride] = useState(""); // GBP per month

  const toNum = (v) => {
    if (v == null || v === "") return 0;
    const n = Number(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };
  const totals = useDebtConsolidationMath(debts, {
    currentMortgages,

    loanAmount:
      toNum(loanAmount) +
      toNum(
        feeMode === "percent"
          ? (toNum(feeValue) / 100) * toNum(loanAmount)
          : toNum(feeValue),
      ),
    apr: toNum(svrApr) || toNum(initialApr) || 0,
    termYears: toNum(termYears),
    termMonths: toNum(termMonths),
    feeMode,
    feeValue: toNum(feeValue),
    initialApr: toNum(initialApr),
    svrApr: toNum(svrApr),
    initialYears: toNum(initialYears),
    initialMonths: toNum(initialMonths),
    initialMonthlyOverride: toNum(initialMonthlyOverride),
    reversionMonthlyOverride: toNum(reversionMonthlyOverride),
  });
  // For display in the input fields (overrides take precedence over auto-calculated):
  // useEffect(() => {
  //   if (!totals) return;

  //   console.group("DebtSense – Annual Calculations");

  //   if (Array.isArray(totals.annualLogExisting)) {
  //     console.log("Existing (Annual)");
  //     console.table(
  //       totals.annualLogExisting.map((r) => ({
  //         Year: r.year,
  //         "Opening (£)": Number(r.openingBalance || 0).toFixed(2),
  //         "Payments (£)": Number(r.totalPayments || 0).toFixed(2),
  //         "Interest (£)": Number(r.interestPaid || 0).toFixed(2),
  //         "Principal (£)": Number(r.principalPaid || 0).toFixed(2),
  //         "Closing (£)": Number(r.closingBalance || 0).toFixed(2),
  //         "Avg APR (%)": Number(r.avgAprPct || 0).toFixed(2),
  //         Notes: r.notes || "",
  //       })),
  //     );
  //   }

  //   if (Array.isArray(totals.annualLogNew)) {
  //     console.log("New Mortgage (Annual)");
  //     console.table(
  //       totals.annualLogNew.map((r) => ({
  //         Year: r.year,
  //         "Opening (£)": Number(r.openingBalance || 0).toFixed(2),
  //         "Payments (£)": Number(r.totalPayments || 0).toFixed(2),
  //         "Interest (£)": Number(r.interestPaid || 0).toFixed(2),
  //         "Principal (£)": Number(r.principalPaid || 0).toFixed(2),
  //         "Closing (£)": Number(r.closingBalance || 0).toFixed(2),
  //         "Avg APR (%)": Number(r.avgAprPct || 0).toFixed(2),
  //         Notes: r.notes || "",
  //       })),
  //     );
  //   }

  //   console.groupEnd();
  // }, [totals]);

  const initialMonthlyDisplay =
    initialMonthlyOverride !== ""
      ? Number(initialMonthlyOverride)
      : Number.isFinite(totals.monthlyPayInitial) &&
          totals.monthlyPayInitial > 0
        ? totals.monthlyPayInitial
        : NaN;

  const reversionMonthlyDisplay =
    reversionMonthlyOverride !== ""
      ? Number(reversionMonthlyOverride)
      : Number.isFinite(totals.monthlyPayReversion) &&
          totals.monthlyPayReversion > 0
        ? totals.monthlyPayReversion
        : NaN;

  // For comparisons (e.g., the green/red sentence), prefer initial override, else initial auto, else monthlyPayNew:
  const newMonthlyForComparison =
    (initialMonthlyOverride !== "" && Number(initialMonthlyOverride)) ||
    (Number.isFinite(totals.monthlyPayInitial) &&
      totals.monthlyPayInitial > 0 &&
      totals.monthlyPayInitial) ||
    totals.monthlyPayNew;

  /* ───────── per-row calc/handlers ───────── */
  const recalcDebt = (d) => {
    const balance = Number(d.balance) || 0;
    const apr = Number(d.apr) || 0;
    const r = aprToMonthly(apr);
    const isRevolving = REVOLVING_TYPES.includes(d.label);
    const isCreditCard = (d.label || "").trim() === "Credit Card";

    if (isRevolving) {
      const planned = Number(d.plannedMonthly) || 0;
      const applied = isCreditCard
        ? Math.max(planned, ccMinPayment(balance))
        : planned;
      const mExact = periodsForPayment(balance, r, applied);
      const m = Number.isFinite(mExact) ? Math.ceil(mExact) : Infinity;
      const years = Number.isFinite(m) ? m / 12 : "";
      return { ...d, monthly: applied, termYears: years };
    }

    const years = Number(d.termYears) || 0;
    const monthly = monthlyFromTerm(balance, apr, years);
    return { ...d, monthly: Number.isFinite(monthly) ? monthly : 0 };
  };

  const updateDebt = (idx, patch) =>
    setDebts((arr) =>
      arr.map((d, i) => {
        if (i !== idx) return d;

        let next = {
          ...d,
          ...patch,
          ...(patch.label && !REVOLVING_TYPES.includes(patch.label)
            ? { plannedMonthly: "" }
            : {}),
        };

        if (patch.label && patch.label !== d.label) {
          const preset = defaultAprForLabel(patch.label, "goodCredit") || "";
          if (preset !== "" && (d._aprAuto || d.apr === "")) {
            next.apr = preset;
            next._aprAuto = true;
          } else if (!(patch.label in AVERAGE_RATES)) {
            next._aprAuto = false;
          }
        }

        // reuse your recalcDebt as-is (but without mortgage special casing)
        next = recalcDebt(next);
        return next;
      }),
    );

  const addDebt = () =>
    setDebts((arr) => {
      const nextLabel = arr.length === 0 ? "Credit Card" : "Other";
      const aprPreset = defaultAprForLabel(nextLabel) || "";
      return [
        ...arr,
        {
          id: arr.length + 1,
          label: nextLabel,
          lockType: false,
          balance: "",
          apr: aprPreset,
          termYears: "",
          plannedMonthly: "",
          monthly: "",
          _aprAuto: aprPreset !== "",
        },
      ];
    });

  const removeDebt = (idx) =>
    setDebts((arr) =>
      arr.filter((_, i) => i !== idx).map((d, i) => ({ ...d, id: i + 1 })),
    );

  // Build narrative text to pass into the PDF report (match "Your Results" panel)
  const reportNarrative = (() => {
    const avgApr = toPct(safeFixed(totals.weightedApr));
    const initRate = toPct(safeFixed(toNum(initialApr)));
    const svrRate = toPct(safeFixed(toNum(svrApr)));

    const initialPeriodText = formatYearsMonths(
      toNum(initialYears) * 12 + toNum(initialMonths),
    );

    const currentMonthlyText = Number.isFinite(totals.totalMonthly)
      ? `£${totals.totalMonthly.toLocaleString("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "£0";

    const newMonthlyText = Number.isFinite(initialMonthlyDisplay)
      ? `£${initialMonthlyDisplay.toLocaleString("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "£0";

    // Monthly change sentence (same logic as UI)
    let monthlyChangeSentence = "";
    const newMonthly = newMonthlyForComparison;

    if (Number.isFinite(totals.totalMonthly) && Number.isFinite(newMonthly)) {
      if (newMonthly < totals.totalMonthly) {
        monthlyChangeSentence =
          " This arrangement will reduce your monthly repayments.";
      } else if (newMonthly > totals.totalMonthly) {
        monthlyChangeSentence =
          " This arrangement will increase your monthly repayments.";
      } else {
        monthlyChangeSentence =
          " Your monthly repayments will be broadly unchanged.";
      }
    }

    // Interest comparison sentence (same as UI)
    let interestSentence = "";
    if (
      Number.isFinite(totals.totalInterestExisting) &&
      Number.isFinite(totals.totalInterestNew)
    ) {
      const diff = totals.totalInterestNew - totals.totalInterestExisting;

      if (diff >= 0) {
        interestSentence =
          ` By consolidating your current debts into the new mortgage, you will pay ` +
          `${toMoney(safeFixed(diff))} more in interest over the full term of ` +
          `${formatYearsMonths(totals.months)}.` +
          ` However, as you are transferring unsecured, short-term debt into a longer-term secured loan, ` +
          `the total interest cost can be higher despite the lower monthly payments.`;
      } else {
        interestSentence =
          ` By consolidating your current debts into the new mortgage, you will pay ` +
          `${toMoney(safeFixed(Math.abs(diff)))} less in interest over the full term of ` +
          `${formatYearsMonths(totals.months)}.`;
      }
    }

    return (
      `The average APR across your existing debts is ${avgApr}. ` +
      `The recommended debt consolidation mortgage offers a fixed interest rate of ${initRate}, ` +
      `for an initial period of ${initialPeriodText}. ` +
      `Once this fixed period ends, the interest rate will revert to the lender’s Standard Variable Rate (SVR), currently ${svrRate}. ` +
      `The figures illustrated within the consolidation mortgage section are based on the initial fixed-rate period only and may vary thereafter depending on future changes to the lender’s SVR. ` +
      `The current monthly payment for mortgage and debt is ${currentMonthlyText}. ` +
      `After combining your unsecured debt within the new consolidation mortgage, the monthly payment for the initial fixed period will be ${newMonthlyText}.` +
      monthlyChangeSentence +
      interestSentence
    );
  })();

  //   useEffect(() => {
  //     console.log(totals);
  //  }, [reportNarrative]);
  // ...inside your component
  const resetAll = () => {
    setDebts([]);
    setCurrentMortgages([{ ...emptyMortgage(), id: 1 }]);
    setLoanAmount("");
    setInitialApr("");
    setSvrApr("");
    setInitialYears("");
    setInitialMonths("");
    setTermYears("");
    setTermMonths("");
    setFeeMode("flat");
    setFeeValue("");
    setCustomerName("");
    setAdviserName(auth.currentUser ? auth.currentUser.displayName : "");
  };

  const handleDownloadPDF = async () => {
    try {
      const memoizedReport = (
        <DCCReport
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
          customerName={customerName}
          adviserName={adviserName}
          debts={debts}
          currentMortgages={currentMortgages}
          loanAmount={loanAmount === "" ? 0 : Number(loanAmount)}
          initialApr={initialApr === "" ? 0 : Number(initialApr)}
          svrApr={svrApr === "" ? 0 : Number(svrApr)}
          initialYears={initialYears === "" ? 0 : Number(initialYears)}
          initialMonths={initialMonths === "" ? 0 : Number(initialMonths)}
          termYears={termYears === "" ? 0 : Number(termYears)}
          termMonths={termMonths === "" ? 0 : Number(termMonths)}
          feeMode={feeMode}
          feeValue={feeValue === "" ? 0 : Number(feeValue)}
          totals={totals}
          narrative={reportNarrative}
          /* NEW: mirror the Monthly Preview widgets exactly */
          initialMonthlyOverride={initialMonthlyOverride}
          reversionMonthlyOverride={reversionMonthlyOverride}
        />
      );

      const blob = await pdf(memoizedReport).toBlob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Debt Consolidation - ${customerName}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Revoke after a tick so the download can start
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } finally {
      // Clear everything after download is triggered
      // resetAll();
    }
  };

  // useEffect(() => {
  //   generateDCCForAllAdvisers();
  // }, []);

  return (
    <div className="dcc-content">
      <Helmet>
        <title>DebtSense</title>
        <meta
          name="description"
          content="Rosemount Financial Solutions (IFA) Ltd - Adviser Portal"
        />
      </Helmet>

      <Sidebar />
      {/* <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <DCCReport
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
          customerName={customerName}
          adviserName={adviserName}
          debts={debts}
          loanAmount={loanAmount === "" ? 0 : Number(loanAmount)}
          initialApr={initialApr === "" ? 0 : Number(initialApr)}
          svrApr={svrApr === "" ? 0 : Number(svrApr)}
          initialYears={initialYears === "" ? 0 : Number(initialYears)}
          initialMonths={initialMonths === "" ? 0 : Number(initialMonths)}
          termYears={termYears === "" ? 0 : Number(termYears)}
          termMonths={termMonths === "" ? 0 : Number(termMonths)}
          feeMode={feeMode}
          feeValue={feeValue === "" ? 0 : Number(feeValue)}
          totals={totals}
          narrative={reportNarrative}
          initialMonthlyOverride={initialMonthlyOverride}
          reversionMonthlyOverride={reversionMonthlyOverride}
        />
      </PDFViewer> */}

      <div className="dcc-main">
        <Breadcrumb items={breadcrumbItems} />
        <div className="dcc-top-buttons">
          <AddEditButton onClick={resetAll} buttonText="Clear" />
        </div>
        <div>
          <h2>DebtSense</h2>
          <div className="SubTitle">Debt Consolidation Calculator</div>
        </div>
        <div className="dcc-container">
          {currentMortgages.map((mortgage, index) => (
            <div key={mortgage.id}>
              <CurrentMortgageCard
                title={currentMortgages.length > 1 ? `Existing Mortgage ${index + 1}` : 'Existing Mortgage'}
                actions={
                  <>
                    {index === 0 && <AddEditButton buttonText="Add another mortgage" onClick={() => setCurrentMortgages(previous => [
                      ...previous, { ...emptyMortgage(), id: Math.max(...previous.map(item => item.id)) + 1 },
                    ])} />}
                    {index > 0 && (
                      <div className="dcc-mortgage-remove" title={`Remove mortgage ${index + 1}`}>
                        <RemoveButton onClick={() => setCurrentMortgages(previous => previous.filter(item => item.id !== mortgage.id))} />
                      </div>
                    )}
                  </>
                }
                value={mortgage}
                onChange={update => updateMortgage(mortgage.id, update)}
              />
            </div>
          ))}
          {currentMortgages.length > 1 && (
            <div className="dcc-panel" style={{ marginTop: 16 }}>
              <div className="Label-Large-Bold">Combined mortgages</div>
              <p>Total balance: {toMoney(currentMortgage.balance)}</p>
              <p>Total monthly payment: {toMoney(currentMortgage.monthly)}</p>
              <p>Weighted current interest rate: {toPct(currentMortgage.apr)}</p>
              <div className="Content-Small">Interest rates are weighted by outstanding balance. Repayment projections use each mortgage’s own term and rate changes.</div>
            </div>
          )}
        </div>{" "}
        <div className="dcc-container">
          <div className="dcc-panel">
            <div className="Label-Large-Bold">Debt to consolidate</div>
            {/* <div className="dcc-input-row ">
              <DCCTooltip />
            </div> */}

            <div className="dcc-input-row">
              <div className="Content-Small">
                Enter the debts you plan to consolidate
              </div>
              <AddEditButton onClick={addDebt} buttonText="Add" />
            </div>

            {debts.length > 0 ? (
              <table className="dcc-table">
                <thead>
                  <tr>
                    <th>
                      <div className="Content-SemiBold">ID</div>
                    </th>
                    <th>
                      <div className="Content-SemiBold">Type of Debt</div>
                    </th>
                    <th>
                      <div className="Content-SemiBold">Balance (£)</div>
                    </th>
                    <th>
                      <div className="Content-SemiBold">Term (Years)</div>
                    </th>
                    <th>
                      <div className="Content-SemiBold">
                        Monthly Payment (£)
                      </div>
                    </th>
                    <th>
                      <div className="Content-SemiBold">
                        <div className="tooltip-row">
                          Interest Rate (%)
                          <TooltipIcon onClick={() => setShowAvgRates(true)} />
                        </div>
                      </div>
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {debts.map((d, i) => (
                    <React.Fragment key={d.id}>
                      <tr>
                        <td>{d.id}</td>

                        {/* Type */}
                        <td>
                          <select
                            value={d.label}
                            onChange={(e) => {
                              if (d.lockType) return;
                              const nextLabel = e.target.value.trim();
                              if (
                                nextLabel === "Current Mortgage" &&
                                hasCurrentMortgage &&
                                d.label !== "Current Mortgage"
                              ) {
                                return;
                              }
                              updateDebt(i, { label: nextLabel });
                            }}
                            className="Content dcc-input"
                            disabled={!!d.lockType}
                          >
                            {typesInDebts.map((type) => {
                              const isCurrent = type === "Current Mortgage";
                              const disableThisOption =
                                isCurrent &&
                                hasCurrentMortgage &&
                                d.label !== "Current Mortgage";
                              return (
                                <option
                                  key={type}
                                  value={type}
                                  disabled={disableThisOption}
                                >
                                  {type}
                                </option>
                              );
                            })}
                          </select>
                        </td>

                        {/* Balance */}
                        <td>
                          <FormattedNumberInput
                            value={d.balance}
                            onChange={(val) => updateDebt(i, { balance: val })}
                            className="Content dcc-input-num"
                          />
                        </td>

                        {/* Term (years) */}
                        {/* Term (years) */}
                        <td>
                          {REVOLVING_TYPES.includes(d.label) ? (
                            <div className="input-wrap readonly">
                              <FormattedNumberInput
                                value={safeFixed(d.termYears) || 0}
                                onChange={() => {}}
                                readOnly
                                className="Content dcc-input-num"
                                title="Calculated from balance, APR and term"
                              />
                              <LockIcon />
                            </div>
                          ) : (
                            <FormattedNumberInput
                              value={d.termYears ?? ""}
                              onChange={(val) =>
                                updateDebt(i, { termYears: val })
                              }
                              decimals={0}
                              placeholder=""
                              title="Enter years"
                              className="Content dcc-input-num"
                            />
                          )}
                        </td>

                        {/* Monthly */}
                        {/* <td>
                          {d.label !== "Current Mortgage" ? (
                            <FormattedNumberInput
                              value={d.plannedMonthly}
                              onChange={(val) =>
                                updateDebt(i, { plannedMonthly: val })
                              }
                              className="Content dcc-input-num"
                              title={(d.label || "").trim()}
                              placeholder=""
                            />
                          ) : (
                            <div className="input-wrap readonly">
                              <FormattedNumberInput
                                value={safeFixed(d.monthly) || 0}
                                onChange={() => {}}
                                readOnly
                                className="Content dcc-input-num"
                                title="Calculated from balance, APR and term"
                              />
                              <LockIcon />
                            </div>
                          )}
                        </td> */}
                        <td>
                          <FormattedNumberInput
                            value={d.plannedMonthly}
                            onChange={(val) =>
                              updateDebt(i, { plannedMonthly: val })
                            }
                            className="Content dcc-input-num"
                          />
                        </td>

                        {/* APR */}
                        {/* APR */}
                        <td>
                          <FormattedNumberInput
                            value={d.apr}
                            onChange={
                              (val) =>
                                updateDebt(i, { apr: val, _aprAuto: false }) // <-- break auto on manual entry
                            }
                            className="Content dcc-input-num"
                          />
                          {/* Optional hint: show the band we used */}
                          {/* <div className="Content-Small" style={{opacity:.7}}>
      {AVERAGE_RATES[d.label]?.goodCredit ? `Preset (good credit): ${AVERAGE_RATES[d.label].goodCredit}` : ""}
     </div> */}
                        </td>

                        {/* Remove */}
                        <td className="dcc-td-right">
                          {!d.lockType && (
                            <RemoveButton onClick={() => removeDebt(i)} />
                          )}
                        </td>
                      </tr>

                      {(d.label || "").trim() === "Credit Card" &&
                        Number(d.monthly) > 0 && (
                          <tr>
                            <td colSpan="7" style={{ padding: "4px 0 12px 0" }}>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#444",
                                  fontStyle: "italic",
                                  textAlign: "right",
                                  marginRight: "12px",
                                }}
                              >
                                Applied monthly payment:&nbsp;
                                <b>
                                  £{" "}
                                  {Number(d.monthly).toLocaleString("en-GB", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </b>{" "}
                                {Number(d.monthly) !==
                                  Number(d.plannedMonthly) &&
                                  "(minimum 1% applied)"}
                              </div>
                            </td>
                          </tr>
                        )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            ) : (
              <hr className="dcc-divider" />
            )}
          </div>
        </div>
        <div className="dcc-container">
          {/* ───────── Inputs panel ───────── */}
          <div className="dcc-panel">
            {/* <div style={{ height: 30 }} /> */}

            <div className="Label-Large-Bold">New Consolidation Mortgage</div>

            {/* Loan amount */}
            <div className="dcc-field">
              <div className="dcc-term-grid">
                <label className="Content-SemiBold dcc-label">
                  Loan Amount* (£)
                </label>
              </div>
              <div className="dcc-term-grid">
                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={loanAmount}
                    onChange={setLoanAmount}
                    className="Content dcc-input-num"
                  />
                </div>
              </div>
            </div>

            <hr className="dcc-divider" />
            <div className="dcc-fees">
              <div className="Content-SemiBold dcc-fees-title">
                Cost and Fees* (if not included in the loan amount)
              </div>
              <div className="dcc-term-grid">
                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={feeValue}
                    onChange={setFeeValue}
                    className="Content dcc-input-num"
                  />
                </div>
                <div className="dcc-field-inrow">
                  <div className="RadioButton-Container">
                    <label className="Radio-Option">
                      <input
                        type="radio"
                        name="feeMode"
                        checked={feeMode === "flat"}
                        onChange={() => setFeeMode("flat")}
                      />
                      <span className="Custom-RadioButton"></span>
                      <div className="Content">£ </div>
                    </label>
                  </div>
                  <div className="RadioButton-Container">
                    <label className="Radio-Option">
                      <input
                        type="radio"
                        name="feeMode"
                        checked={feeMode === "percent"}
                        onChange={() => setFeeMode("percent")}
                      />
                      <span className="Custom-RadioButton"></span>
                      <div className="Content">%</div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Rates */}
            <hr className="dcc-divider" />
            <div className="dcc-field">
              <div className="dcc-term-grid">
                <label className="Content-SemiBold dcc-label">
                  Initial Interest Rate* (%)
                </label>
                <div className="dcc-label-row">
                  <label className="Content-SemiBold dcc-label">
                    Standard Variable Rate (%)
                  </label>

                  <InfoTooltip
                    text="Please enter your lender’s current Standard Variable Rate (%)."
                    position="top"
                  />
                </div>
              </div>
              <div className="dcc-term-grid">
                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={initialApr}
                    onChange={setInitialApr}
                    className="Content dcc-input-num"
                  />
                </div>
                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={svrApr}
                    onChange={setSvrApr}
                    className="Content dcc-input-num"
                  />
                </div>
              </div>
            </div>

            {/* Initial period + Total term */}
            <hr className="dcc-divider" />
            <div className="dcc-term-grid">
              <div className="dcc-field">
                <label className="Content-SemiBold dcc-label">
                  Initial Fixed Period*
                </label>
                <div className="dcc-term-grid">
                  <div className="dcc-field-inline">
                    <FormattedNumberInput
                      value={initialYears}
                      onChange={setInitialYears}
                      decimals={0}
                      className="Content dcc-input-num"
                    />

                    <div className="Content-Small dcc-subtext">Years</div>
                  </div>
                  <div className="dcc-field-inline">
                    <FormattedNumberInput
                      value={initialMonths}
                      onChange={setInitialMonths}
                      decimals={0}
                      className="Content dcc-input-num"
                    />

                    <div className="Content-Small dcc-subtext">Months</div>
                  </div>
                </div>
              </div>

              <div className="dcc-field">
                <label className="Content-SemiBold dcc-label">Loan Term*</label>
                <div className="dcc-term-grid">
                  <div className="dcc-field-inline">
                    <FormattedNumberInput
                      value={termYears}
                      decimals={0}
                      onChange={setTermYears}
                      className="Content dcc-input-num"
                    />

                    <div className="Content-Small dcc-subtext">Years</div>
                  </div>
                  <div className="dcc-field-inline">
                    <FormattedNumberInput
                      value={termMonths}
                      decimals={0}
                      onChange={setTermMonths}
                      className="Content dcc-input-num"
                    />

                    <div className="Content-Small dcc-subtext">Months</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Monthly payments preview (read-only) */}
            <hr className="dcc-divider" />
            <div className="dcc-field">
              <div className="dcc-term-grid">
                <label className="Content-SemiBold dcc-label">
                  Initial Monthly Payment
                </label>
                <label className="Content-SemiBold dcc-label">
                  Monthly Payment After the Initial Period
                </label>
              </div>
              <div className="dcc-term-grid">
                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={
                      initialMonthlyOverride !== ""
                        ? initialMonthlyOverride
                        : Number.isFinite(initialMonthlyDisplay)
                          ? String(initialMonthlyDisplay)
                          : ""
                    }
                    onChange={(val) => {
                      // empty string => revert to auto mode
                      setInitialMonthlyOverride(val);
                    }}
                    className="Content dcc-input-num"
                    title="Initial monthly payment (you can override; clear to revert to auto)"
                    placeholder=""
                    // placeholder={
                    //   Number.isFinite(totals.monthlyPayInitial) &&
                    //   totals.monthlyPayInitial > 0
                    //     ? `Auto: £${totals.monthlyPayInitial.toLocaleString(
                    //         "en-GB",
                    //         {
                    //           minimumFractionDigits: 2,
                    //           maximumFractionDigits: 2,
                    //         }
                    //       )}`
                    //     : "Enter amount"
                    // }
                  />
                </div>

                <div className="dcc-field-inline">
                  <FormattedNumberInput
                    value={
                      reversionMonthlyOverride !== ""
                        ? reversionMonthlyOverride
                        : Number.isFinite(reversionMonthlyDisplay)
                          ? String(reversionMonthlyDisplay)
                          : ""
                    }
                    onChange={(val) => {
                      // empty string => revert to auto mode
                      setReversionMonthlyOverride(val);
                    }}
                    className="Content dcc-input-num"
                    title="Reversionary monthly payment (you can override; clear to revert to auto)"
                    placeholder=""
                    // placeholder={
                    //   Number.isFinite(totals.monthlyPayReversion) &&
                    //   totals.monthlyPayReversion > 0
                    //     ? `Auto: £${totals.monthlyPayReversion.toLocaleString(
                    //         "en-GB",
                    //         {
                    //           minimumFractionDigits: 2,
                    //           maximumFractionDigits: 2,
                    //         }
                    //       )}`
                    //     : "Enter amount"
                    // }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ───────── Results panel ───────── */}
          <div className="dcc-panel">
            <div className="Label-Large-Bold">Your Results</div>
            <div className="Content">
              The average APR across your existing debts is{" "}
              <b>{toPct(safeFixed(totals.weightedApr))}</b>. The recommended
              debt consolidation mortgage offers a fixed interest rate of{" "}
              <b>{toPct(safeFixed(toNum(initialApr)))}</b>, for an initial
              period of{" "}
              <b>
                {formatYearsMonths(
                  toNum(initialYears) * 12 + toNum(initialMonths),
                )}
              </b>
              . Once this fixed period ends, the interest rate will revert to
              the lender’s Standard Variable Rate (SVR), currently{" "}
              <b>{toPct(safeFixed(toNum(svrApr)))}</b>. The figures illustrated
              within the consolidation mortgage section are based on the initial
              fixed-rate period only and may vary thereafter depending on future
              changes to the lender’s SVR. The current monthly payment for
              mortgage and debt is{" "}
              <b>
                {" "}
                {Number.isFinite(totals.totalMonthly)
                  ? `£${totals.totalMonthly.toLocaleString("en-GB", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : "£0"}
              </b>
              . After combining your unsecured debt within the new consolidation
              mortgage, the monthly payment for the initial fixed period will be
              <b>
                {" "}
                {Number.isFinite(initialMonthlyDisplay)
                  ? `£${initialMonthlyDisplay.toLocaleString("en-GB", {
                      minimumFractionDigits: 2,

                      maximumFractionDigits: 2,
                    })}`
                  : "£0"}
              </b>
              .{" "}
              {/* increasing to <b>{toPct(safeFixed(toNum(svrApr)))}</b>{" "}
              if you remain on the lender’s <b>Standard Variable Rate (SVR)</b>{" "}
              after the introductory period.{" "} */}
              {(() => {
                const newMonthly = newMonthlyForComparison;
                if (
                  Number.isFinite(totals.totalMonthly) &&
                  Number.isFinite(newMonthly)
                ) {
                  return newMonthly < totals.totalMonthly ? (
                    <span className="Content-SemiBold green">
                      This arrangement will reduce your monthly repayments.
                    </span>
                  ) : newMonthly > totals.totalMonthly ? (
                    <span className="Content-SemiBold red">
                      This arrangement will increase your monthly repayments.
                    </span>
                  ) : (
                    <span className="Content-SemiBold">
                      Your monthly repayments will be broadly unchanged.
                    </span>
                  );
                }
                return null;
              })()}
              {/* {Number.isFinite(totals.fee) && totals.fee > 0 ? (
                <>
                  <br />
                  Including the <b>{toMoney(safeFixed(totals.fee))}</b> fee
                  added to the loan, your total <b>borrowing</b> will amount to{" "}
                  <b>
                    {toMoney(
                      safeFixed(loanAmount === "" ? 0 : Number(loanAmount)),
                    )}
                  </b>
                  .
                </>
              ) : (
                <>
                    {" "}Your total borrowing will amount to{" "}
                  <b>
                    {toMoney(
                      safeFixed(loanAmount === "" ? 0 : Number(loanAmount)),
                    )}
                  </b>
                  .
                </>
              )}{" "} */}
              <div style={{ height: 5 }} />
              {Number.isFinite(totals.totalInterestExisting) &&
              Number.isFinite(totals.totalInterestNew) ? (
                totals.totalInterestNew >= totals.totalInterestExisting ? (
                  <>
                    <br />
                    By consolidating your current debts into the new mortgage,
                    you will pay{" "}
                    <b>
                      {toMoney(
                        safeFixed(
                          totals.totalInterestNew -
                            totals.totalInterestExisting,
                        ),
                      )}
                    </b>{" "}
                    more in interest over the full term of{" "}
                    <b>{formatYearsMonths(totals.months)}</b>. However, as you
                    are transferring unsecured, short-term debt into a
                    longer-term secured loan, the total interest cost can be
                    higher despite the lower monthly payments.
                  </>
                ) : (
                  <>
                    By consolidating your current debts into the new mortgage,
                    you will pay{" "}
                    <b>
                      {toMoney(
                        safeFixed(
                          totals.totalInterestExisting -
                            totals.totalInterestNew,
                        ),
                      )}
                    </b>{" "}
                    less in interest over the full term of{" "}
                    <b>{formatYearsMonths(totals.months)}</b>.
                  </>
                )
              ) : null}
            </div>
            {totals.warnNeverPaysOff && (
              <div className="Content dcc-warning">
                Your combined monthly payment is not enough to reduce the
                existing balance at the current blended APR.
              </div>
            )}
            <div style={{ height: 20 }} />
            <table className="dcc-table dcc-results">
              <thead>
                <tr>
                  <th />
                  <th>
                    <div className="Content-SemiBold">Existing Debts</div>
                  </th>
                  <th>
                    <div className="Content-SemiBold">
                      Consolidation Mortgage
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="Content-SemiBold">Rates</td>
                  <td className="Content">
                    {toPct(safeFixed(totals.weightedApr))}
                  </td>
                  <td className="Content">
                    <span>Initial Fixed Rate:</span>{" "}
                    {toPct(safeFixed(toNum(initialApr)))}
                    <br />
                    <span>Standard Variable Rate:</span>{" "}
                    {toPct(safeFixed(toNum(svrApr)))}
                  </td>
                </tr>
                <tr>
                  <td className="Content-SemiBold">Time to Payoff</td>
                  <td className="Content">
                    {Number.isFinite(totals.nExisting)
                      ? `${Math.ceil(totals.nExisting)} months`
                      : "0 months"}
                  </td>
                  <td className="Content">
                    {totals.months > 0 ? `${totals.months} months` : "0 months"}
                  </td>
                </tr>

                <tr>
                  <td className="Content-SemiBold">Associated Fees</td>
                  <td className="Content">{toMoney(0)}</td>
                  <td className="Content">{toMoney(safeFixed(totals.fee))}</td>
                </tr>

                {/* <tr>
                  <td className="Content-SemiBold">Total Level of Borrowing</td>
                  <td className="Content">{toMoney(0)}</td>
                  <td className="Content">
                    {toMoney(
                      safeFixed(loanAmount === "" ? 0 : Number(loanAmount)),
                    )}
                  </td>
                </tr> */}

                <tr>
                  <td className="Content-SemiBold">Monthly Pay</td>
                  <td className="Content-SemiBold red">
                    {toMoney(safeFixed(totals.totalMonthly))}
                  </td>
                  <td className="Content-SemiBold green">
                    {/* Initial step: prefer override, else auto, else dash */}
                    {Number.isFinite(
                      (initialMonthlyOverride !== "" &&
                        Number(initialMonthlyOverride)) ||
                        initialMonthlyDisplay,
                    )
                      ? toMoney(
                          safeFixed(
                            (initialMonthlyOverride !== "" &&
                              Number(initialMonthlyOverride)) ||
                              initialMonthlyDisplay,
                          ),
                        ) + " (Initial Fixed Rate)"
                      : "£0.00"}{" "}
                    <br />
                    {/* Reversion step: show arrow + value if available */}
                    {Number.isFinite(
                      (reversionMonthlyOverride !== "" &&
                        Number(reversionMonthlyOverride)) ||
                        reversionMonthlyDisplay,
                    ) && (
                      <>
                        {toMoney(
                          safeFixed(
                            (reversionMonthlyOverride !== "" &&
                              Number(reversionMonthlyOverride)) ||
                              reversionMonthlyDisplay,
                          ),
                        )}{" "}
                        (Standard Variable Rate)
                      </>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="Content-SemiBold">
                    Total Amount to be Repaid
                  </td>
                  <td className="Content-SemiBold red">
                    {toMoney(safeFixed(totals.totalPaymentsExisting))}
                  </td>
                  <td className="Content-SemiBold green">
                    {dashIfNaN(totals.totalPaymentsNew)}
                  </td>
                </tr>

                <tr>
                  <td className="Content-SemiBold">
                    Total Interest Over the Term
                  </td>
                  <td className="Content-SemiBold red">
                    {toMoney(safeFixed(totals.totalInterestExisting))}
                  </td>
                  <td className="Content-SemiBold green">
                    {dashIfNaN(totals.totalInterestNew)}
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <div style={{ height: 15 }} />
            However, consolidating the existing unsecured debt into a new
            secured mortgage would result in an additional{" "}
            <b>
              {toMoney(
                safeFixed(
                  Math.abs(
                    totals.totalInterestNew - totals.totalInterestExisting,
                  ),
                ),
              )}
            </b>{" "}
            in interest costs over the full term of the mortgage. */}
          </div>
        </div>
        <InputField
          title="Client Name*"
          placeholder="Ava Smith"
          name="customerName"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          // required={customerName === "" ? true : false}
          isTextarea={false}
        />
        <InputField
          title="Adviser Name*"
          placeholder="Noah Johnson"
          name="adviserName"
          value={adviserName}
          onChange={(e) => setAdviserName(e.target.value)}
          // required={adviserName === "" ? true : false}
          isTextarea={false}
        />
        <form className="ATRForm-Container"></form>
        <ButtonYellow
          onClick={handleDownloadPDF}
          buttonText="Download Report"
        />
        <AverageRatesModal
          open={showAvgRates}
          onClose={() => setShowAvgRates(false)}
          rates={AVERAGE_RATES}
        />
      </div>
    </div>
  );
}
